module.exports = __webpack_public_path__ + "media/images/icon-svg/check-red-1dd18772b2a4b22c66df96afec8ee78f.svg";